import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EmojiDirective } from './emoji.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [EmojiDirective],
  exports: [EmojiDirective],
})
export class EmojiHelperModule {}
